import { btnDemo } from '../components/cta';
import { eyebrow, mesh } from '../components/primitives';
import { routeHref } from '../lib/links';

export function page404(): string {
  return `
  <section class="hero center" aria-labelledby="h1">
    ${mesh('soft')}
    <div class="wrap rv">
      ${eyebrow('404')}
      <h1 id="h1" style="margin:22px auto 20px">Page not found.</h1>
      <div class="ctas"><a class="btn btn-ghost" href="${routeHref('/')}">Home</a><a class="btn btn-ghost" href="${routeHref('/platform')}">Platform</a>${btnDemo()}</div>
    </div>
  </section>`;
}
